import { ref } from 'vue';
import { defineStore } from 'pinia';

export type AlertType = 'success' | 'error' | 'warning' | 'info';

export const useAlertStore = defineStore('globalAlert', () => {
	const isOpen = ref(false);
	const message = ref('');
	const type = ref<AlertType>('success');
	const timeout = ref(4000);

	function showAlert(msg: string, alertType: AlertType = 'success', duration = 4000): void {
		message.value = msg;
		type.value = alertType;
		timeout.value = duration;
		isOpen.value = true;
	}

	function closeAlert(): void {
		isOpen.value = false;
	}

	return {
		isOpen,
		message,
		type,
		timeout,
		showAlert,
		closeAlert,
	};
});
